import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<app-loading-screen></app-loading-screen><router-outlet></router-outlet>',
})
export class AppComponent {
  title = 'Panel';
}
